import Vue from 'vue'
import Vuex from 'vuex'
import lists from './lists'
import tasks from './tasks'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    lists, tasks
  },
  actions: {
    preloadContent ({commit, dispatch}, {lists, tasks}) {
      commit('loadLists', JSON.parse(lists))
      commit('loadTasks', JSON.parse(tasks))
    },
    uploadTasksToLocalStorage ({commit, getters}) {
      localStorage.setItem('tasks', JSON.stringify(getters.tasks))
    },
    uploadListsToLocalStorage ({commit, getters}) {
      localStorage.setItem('lists', JSON.stringify(getters.lists))
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js